import * as yup from "yup";
import { MAX_LENGTHS } from "../constants/options";
const phoneRegExp =
  /^((\\+(?!(0))[1-9]{1,4}[ \\-]*)|(\\((?!(0))[0-9]{2,3}\\)[ \\-]*)|((?!(0))[0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const pinRegExp = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;

export const BasicDetailsSchema = yup.object().shape({
  gender: yup.string().required("select_gender"),
  firstName: yup
    .string()
    .max(50, "max_char_flname")
    .required("required_first_name")
    .trim(),
  lastName: yup
    .string()
    .max(50, "max_char_flname")
    .required("required_last_name"),
  middleName: yup
    .string()
    .max(50, "max_char_flname"),
  selectedOption: yup.string().required("required_birthdate_age"),
  birthDate: yup
    .date()
    .min(new Date(new Date().getFullYear() - 100, 1, 1), "invalid_birthdate")
    .when("selectedOption", (id, schema) => {
      return id === "dob" ? schema.required("required_birthdate") : schema;
    }),
  age: yup
    .number()
    .moreThan(0, "invalid_age")
    .lessThan(101, "invalid_age")
    .when("selectedOption", (id, schema) => {
      return id === "age" ? schema.required("required_age") : schema;
    }),
  id: yup.string(),
  idNumber: yup
    .string()
    .when("id", (id, schema) => {
      return schema.max(MAX_LENGTHS[id], "invalid_id");
    })
    .when("id", (id, schema) => {
      return id === "abha" ? schema.matches(new RegExp(`^[0-9]{${MAX_LENGTHS[id]}}$`), "invalid_id") : schema;
    }),
  mobileNumber: yup
    .string()
    .required("required_mobile")
    .matches(phoneRegExp, "required_mobile")
    .min(10, "required_mobile"),
});

export const EmergencyContactSchema = yup.object().shape({
  relationship: yup.string().required("select_relation"),
  name: yup
    .string()
    .max(50, "max_char_flname")
    .required("required_name")
    .trim(),
  contactNumber: yup
    .string()
    .required("required_contact")
    .matches(phoneRegExp, "required_contact")
    .min(10, "required_contact"),
});

export const AddressSchema = yup.object().shape({
  state: yup.string().required("require_state").nullable(),
  district: yup.string().required("required_district").nullable(),
  street1: yup.string().required("required_street1"),
  city: yup.string().required("required_city").nullable(),
  pincode: yup
    .string()
    .required("required_pin")
    .matches(pinRegExp, "invalid_pin")
    .min(6, "invalid_pin"),
});

export const AdvanceSearchSchema = yup.object().shape({
  patientName: yup.string().max(50, "max_char_flname"),
  idInAdvSearch: yup.string().max(14, "invalid_id"),
  phone: yup
    .string()
    .matches(phoneRegExp, "required_mobile")
    .min(10, "required_mobile")
    .max(10, "required_mobile"),
});

export const AssignedLocationsSchema = yup.object().shape({
  village: yup.string().required("required_village"),
  subCenter: yup.string().required("subCenter"),
  uphcPhc: yup.string().required("uphcPhc"),
});

export const AshaDetailsSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(50, "max_char_flname")
    .required("required_first_name")
    .trim(),
  lastName: yup
    .string()
    .max(50, "max_char_flname")
    .required("required_last_name"),
  selectedOption: yup.string().required("required_birthdate_age"),
  birthDate: yup
    .date()
    .min(
      new Date(new Date().getFullYear() - 100, 1, 1),
      "invalid_practitioner_age"
    )
    .when("selectedOption", (id, schema) => {
      return id === "dob"
        ? schema.required("invalid_practitioner_age")
        : schema;
    }),
  age: yup
    .number()
    .moreThan(17, "invalid_practitioner_age")
    .lessThan(101, "invalid_practitioner_age")
    .when("selectedOption", (id, schema) => {
      return id === "age" ? schema.required("required_age") : schema;
    }),
  ashaId: yup.string().required("required_ashaid"),
  mobileNumber: yup
    .string()
    .required("required_mobile")
    .matches(phoneRegExp, "required_mobile")
    .min(10, "required_mobile"),
  village: yup.string().required("require_village").nullable(),
  state: yup.string().required("require_state").nullable(),
  district: yup.string().required("required_district").nullable(),
  pincode: yup
    .string()
    .required("required_pin")
    .matches(pinRegExp, "invalid_pin")
    .min(6, "invalid_pin"),
  subCenter: yup.string().required("required_subcenter"),
  uphcPhc: yup.string().required("required_uphcPhc"),
});
